module.exports = __webpack_public_path__ + "7f54b024538da8c4bc047ae97365e604.MP3";